/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

export default {
    baseStyle: ({theme: {textStyles}}) => ({
        wrapper: {
            // must match header.mainContainer
            minWidth: 'xs',
            maxWidth: 'container.xxl',
            width: 'full',
            mx: 'auto',
            paddingX: {
                base: 4,
                lg: 6,
                xl: 8
            },
            paddingY: 4
        },
        container: {
            color: 'stokkeCore.black',
            _hover: {
                // dim all except the hovered breadcrumb link
                '.chakra-breadcrumb__list-item > *:not(.chakra-breadcrumb__link:hover)': {
                    opacity: 0.5
                }
            }
        },
        item: {
            whiteSpace: 'nowrap'
        },
        link: {
            ...textStyles['Light Medium'],
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            _hover: {
                textDecoration: 'none'
            },
            _focusVisible: {
                boxShadow: 'none'
            },

            // use the default cursor for breadcrumb link that are not links
            '&:not(a)': {
                cursor: 'default'
            }
        },
        separator: {
            mx: 2
        },
        separatorIcon: {
            width: 1.5
        }
    })
}
